import { render, staticRenderFns } from "./PageBargainForm.vue?vue&type=template&id=a08ea930&scoped=true"
import script from "./PageBargainForm.vue?vue&type=script&lang=js"
export * from "./PageBargainForm.vue?vue&type=script&lang=js"
import style0 from "./PageBargainForm.vue?vue&type=style&index=0&id=a08ea930&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08ea930",
  null
  
)

export default component.exports